var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationSecondary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1577 22.2086L9.5 22.7829L8.84227 22.2086C3.31131 17.379 0.5 13.1621 0.5 9.45532C0.5 4.20599 4.59705 0.455322 9.5 0.455322C14.4029 0.455322 18.5 4.20599 18.5 9.45532C18.5 13.1621 15.6887 17.379 10.1577 22.2086ZM6.5 9.45532C6.5 7.79847 7.84315 6.45532 9.5 6.45532C11.1569 6.45532 12.5 7.79847 12.5 9.45532C12.5 11.1122 11.1569 12.4553 9.5 12.4553C7.84315 12.4553 6.5 11.1122 6.5 9.45532Z",
    fill: "#15161B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSecondary);
export default __webpack_public_path__ + "static/media/location-secondary.4dc52a87.svg";
export { ForwardRef as ReactComponent };